// extracted by mini-css-extract-plugin
module.exports =  {"btn":"b7635b5199--btn--vZTMo","spinner":"b7635b5199--spinner--nrwpI","content":"b7635b5199--content--HGq1s","content-loading":"b7635b5199--content-loading--Ynnn6"};